import React from 'react';

function IdentificationBadge(props: object) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 16.25C13.6569 16.25 15 14.9069 15 13.25C15 11.5931 13.6569 10.25 12 10.25C10.3431 10.25 9 11.5931 9 13.25C9 14.9069 10.3431 16.25 12 16.25Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 18.5C8.02395 17.8014 8.70336 17.2344 9.48442 16.8438C10.2655 16.4533 11.1267 16.25 12 16.25C12.8733 16.25 13.7345 16.4533 14.5156 16.8438C15.2966 17.2344 15.976 17.8014 16.5 18.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 20.75V4.25C19.5 3.83579 19.1642 3.5 18.75 3.5L5.25 3.5C4.83579 3.5 4.5 3.83579 4.5 4.25L4.5 20.75C4.5 21.1642 4.83579 21.5 5.25 21.5H18.75C19.1642 21.5 19.5 21.1642 19.5 20.75Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 6.5H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default IdentificationBadge;
